import React from "react"
import {
	checkboxStructure,
	RiskSettingsFieldNames,
	RiskSettingsType,
	showProhibitedBusinessVerticalsAndCountries,
} from "./RiskSettingsUtils"
import {FormikProps} from "formik"
import AcceptableTypesOfIdentificationEditMode from "./AcceptableTypesOfIdentification/EditMode/AcceptableTypesOfIdentificationEditMode"
import ProhibitedBusinessVerticalsEditMode from "./ProhibitedBusinessVerticals/EditMode/ProhibitedBusinessVerticalsEditMode"
import ProhibitedCountriesEditMode from "./ProhibitedCountries/EditMode/ProhibitedCountriesEditMode"

interface RiskSettingsEditModeProps {
	value: RiskSettingsType
	defaultValue?: RiskSettingsType
	handleChange: FormikProps<RiskSettingsType>["handleChange"]
	setFieldTouched: FormikProps<unknown>["setFieldTouched"]
	setFieldValue: FormikProps<unknown>["setFieldValue"]
}

export default function RiskSettingsEditMode({
	value,
	defaultValue,
	handleChange,
	setFieldTouched,
	setFieldValue,
}: RiskSettingsEditModeProps) {
	return (
		<>
			<AcceptableTypesOfIdentificationEditMode
				name={RiskSettingsFieldNames.AcceptableTypesOfIdentification}
				value={value[RiskSettingsFieldNames.AcceptableTypesOfIdentification]}
				defaultValue={defaultValue ? defaultValue[RiskSettingsFieldNames.AcceptableTypesOfIdentification] : undefined}
				handleChange={handleChange}
				setFieldTouched={setFieldTouched}
				checkboxStructure={checkboxStructure}
			/>
			{showProhibitedBusinessVerticalsAndCountries && (
				<>
					<ProhibitedBusinessVerticalsEditMode
						name={RiskSettingsFieldNames.ProhibitedBusinessVerticals}
						value={value[RiskSettingsFieldNames.ProhibitedBusinessVerticals]}
						defaultValue={defaultValue ? defaultValue[RiskSettingsFieldNames.ProhibitedBusinessVerticals] : undefined}
						setFieldValue={setFieldValue}
						setFieldTouched={setFieldTouched}
					/>
					<ProhibitedCountriesEditMode
						name={RiskSettingsFieldNames.ProhibitedCountries}
						value={value[RiskSettingsFieldNames.ProhibitedCountries]}
						defaultValue={defaultValue ? defaultValue[RiskSettingsFieldNames.ProhibitedCountries] : undefined}
						setFieldValue={setFieldValue}
						setFieldTouched={setFieldTouched}
					/>
				</>
			)}
		</>
	)
}
